import Tooltip from "./Tooltip";

export default function Field({ label, help, children, required, error }) {
  return (
    <div style={{ marginBottom: 13 }}>
      <label style={{
        display: "flex", alignItems: "center", gap: 3,
        fontSize: 12, fontWeight: 600, color: "#555555",
        marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.04em",
      }}>
        {label}
        {required && <span style={{ color: "#ef4444" }}>*</span>}
        {help && <Tooltip text={help} />}
      </label>
      {children}
      {error && (
        <div style={{ fontSize: 10, color: "#ef4444", marginTop: 3, fontWeight: 500 }}>
          {error}
        </div>
      )}
    </div>
  );
}

export const inputStyle = {
  width: "100%", padding: "8px 12px", borderRadius: 8,
  border: "1px solid rgba(128,128,128,0.08)", fontSize: 14, outline: "none",
  boxSizing: "border-box", fontFamily: "inherit",
  background: "rgba(128,128,128,0.08)", color: "#555555",
};

export const inputErrorStyle = {
  ...inputStyle,
  border: "1px solid #C02646",
  background: "#fef2f2",
};

export const selectStyle = { ...inputStyle, cursor: "pointer" };
